import React, { Component } from "react";
import ImageOptions from "./ImageOptions";
import {
  heightPercentageToDP,
  widthPercentageToDP,
} from "../../Utils/ResponsiveScreen";
import "react-image-crop/dist/ReactCrop.css";
import MDEditor from "@uiw/react-md-editor";
import CreateMultiDynamicButtons from "./CreateMultiDynamicButtons";
import ImageUpload from "./ImageUpload";
import AwsConfig from "../../Config/AwsConfig";
import StoryUploadTypes from "./StoryUploadTypes";

export default class LiveNewsSectionDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  updatecontentNewLinkDetails = (linkInput, index) => {
    const {
      liveNewsStateValues,
      liveNewsSectionDetails,
      disableSyncToWordPress,
    } = this.props;
    linkInput.map((buttonObj) => {
      if (
        buttonObj.category == "socialMedia" &&
        buttonObj.buttonPosition == "default"
      ) {
        const input = {
          instagramLink: buttonObj.instagramLink,
          youtubeLink: buttonObj.youtubeLink,
          twitterLink: buttonObj.twitterLink,
          websiteLink: "",
          urlType: buttonObj.urlType?.replace("Link", ""),
          watchType: "watchVideo",
        };
        liveNewsStateValues[index].contentLinkDetails = liveNewsSectionDetails[
          index
        ].contentLinkDetails = input;
        liveNewsSectionDetails[index].isEdited = true;
        this.props.updateInParent("", liveNewsSectionDetails, "liveNews");
      } else {
        liveNewsStateValues[index].contentLinkDetails = liveNewsSectionDetails[
          index
        ].contentLinkDetails = {};
        liveNewsSectionDetails[index].isEdited = true;
        this.props.updateInParent("", {}, "liveNews");
      }
    });
    const linkInputData = linkInput[0];

    if (linkInputData && linkInputData.urlType) {
      this.props.disableSyncToWordPress(true);
    } else if (
      linkInputData &&
      (linkInputData.instagramLink ||
        linkInputData.youtubeLink ||
        linkInputData.twitterLink)
    ) {
      this.props.disableSyncToWordPress(false);
    }
    liveNewsStateValues[index].contentNewLinkDetails = liveNewsSectionDetails[
      index
    ].contentNewLinkDetails = linkInput;
    liveNewsSectionDetails[index].isEdited = true;
    this.props.updateInParent("", liveNewsSectionDetails, "liveNews");
  };
  render() {
    const {
      liveNewsSectionDetails,
      liveNewsStateValues,
      section,
      index,
      syncToWordpress,
      disableSyncToWordPress,
    } = this.props;
    const images =
      liveNewsStateValues[index].liveNewsImages &&
      liveNewsStateValues[index].liveNewsImages.length > 0
        ? liveNewsStateValues[index].liveNewsImages
        : liveNewsStateValues[index].liveNewsYoutubeImages;
    return (
      <div class="content">
        <div class="row">
          <text for="text">Title :</text>
          <textarea
            type="text"
            onChange={(value, section) => {
              this.props.handleTitle(value, section, index);
            }}
            value={liveNewsStateValues[index].liveNewsTitle}
            placeholder="Please Enter  Title"
          ></textarea>
          {this.props.hastitleError(index) ? (
            <text for="text" style={{ color: "red", fontSize: 10 }}>
              Title Cannot Be Empty
            </text>
          ) : null}
        </div>
        {syncToWordpress ? (
          <div class="row">
            <text for="text">Permalink :</text>
            <textarea
              type="text"
              onChange={(value) => {
                this.props.handlePermalink(value, section, index);
              }}
              value={liveNewsStateValues[index].permalink}
              placeholder="Please Enter  Permalink"
            ></textarea>
            {/* {liveNewsStateValues[index].isPermalinkNotInEnglish ? (
                                      <text for='text' style={{ color: 'red', fontSize: 10 }}>
                                          Invalid Character or not in English
                                      </text>
                                  ) : null} */}
          </div>
        ) : null}
        <div
          class="col-md-12"
          style={{ marginTop: 5, marginBottom: 5, marginLeft: -5 }}
        >
          <input
            type="checkbox"
            // onChange={this.props.handleMarkDownEditor(index)}
            // checked={liveNewsStateValues[index].markDownEditor}
            style={{ marginRight: 5, marginLeft: 0 }}
          ></input>
          <text for="text">Markdown Description</text>
        </div>

        <div class="row">
          <text for="text">Read More Link :</text>
          <input
            type="text"
            onChange={(value) => {
              this.props.handleReadMoreLink(value, index);
            }}
            value={liveNewsStateValues[index].readMoreLink}
            placeholder="Please Enter  Read More Link"
          ></input>
        </div>
        <div class="row">
          <text for="text">Card Description :</text>
          <MDEditor
            preview={
              liveNewsStateValues[index].markDownEditor ? "live" : "edit"
            }
            value={liveNewsStateValues[index].liveNewsDescription}
            onChange={(value) =>
              this.props.handleMDCardDescription(value, index)
            }
          />
          {this.props.hasCardDescriptionError(index) ? (
            <text for="text" style={{ color: "red", fontSize: 10 }}>
              Description Cannot Be Empty
            </text>
          ) : null}
        </div>
        {/* <div>
          <input
            type="checkbox"
            onChange={() => this.props.handleChangeShowRating(index)}
            checked={liveNewsStateValues[index].showRating}
          />
          <label style={{ marginLeft: widthPercentageToDP("1") }}>
            Show Review Rating
          </label>
        </div>
        {liveNewsStateValues[index].showRating ? (
          <div>
            <text for="text">Review Rating: </text>
            <div>
              <input
                type="text"
                onChange={(value) => {
                  this.props.handleReviewRating(value, index);
                }}
                value={liveNewsStateValues[index].reviewRating}
                placeholder="Please Enter Review Rating"
              ></input>
            </div>
          </div>
        ) : null} */}
        <CreateMultiDynamicButtons
          editContent={this.props.editContent}
          contentNewLinkDetails={
            liveNewsStateValues[index].contentNewLinkDetails
          }
          updatecontentNewLinkDetails={this.updatecontentNewLinkDetails}
          markdownLinkLables={liveNewsStateValues[index].matchedLinkTexts}
          sectionIndex={index}
        />
        <StoryUploadTypes
          handleType={this.props.handleType}
          selectedtype={liveNewsStateValues[index].selectedtype}
          sectionIndex={index}
          selectedContentType={this.props.selectedContentType}
        />

        {liveNewsStateValues[index].selectedtype == "Image" ? (
          <div>
            <div class="row">
              <text for="text">Upload Section Image :</text>
              <p for="text" style={{ color: "red", fontSize: 10 }}>
                (Only JPG and JPEG images are allowed)
              </p>
              <div className="App">
                <ImageUpload
                  pushImageObj={this.props.pushImageObj}
                  setFeaturedImageId={this.props.setFeaturedImageId}
                  multiImages={true}
                  circularCrop={false}
                  sectionIndex={this.props.index}
                />

                {images?.map((item, imageIndex) => {
                  const {
                    copyRightText,
                    copyRight,
                    shareImage,
                    imageValue,
                    image,
                  } = item;
                  const cdnurl = AwsConfig.cdn_url;
                  let finalImage = image ? image : "";
                  if (finalImage && !finalImage.includes(cdnurl)) {
                    finalImage = cdnurl + image;
                  }
                  const key = item.key ? item.key : item.image;
                  const srcImg = image ? finalImage : imageValue;
                  return (
                    <div className="imagesContainer" key={imageIndex}>
                      <img style={{ maxWidth: "100%" }} src={srcImg} />
                      <button
                        onClick={() =>
                          this.props.removeImage(imageIndex, this.props.index)
                        }
                      >
                        Remove Image
                      </button>
                      <div className="imgPreview">
                        <ImageOptions
                          syncToWordpress={syncToWordpress}
                          item={item}
                          copyRight={copyRight}
                          copyRightText={copyRightText}
                          sectionIndex={this.props.index}
                          toggleCopyRightSwitch={(item, index) =>
                            this.props.toggleCopyRightSwitch(item, index)
                          }
                          handleCopyrightType={(item, copyrightPrefix, index) =>
                            this.props.handleCopyrightType(
                              item,
                              copyrightPrefix,
                              index
                            )
                          }
                          handleCopyrightText={this.props.handleCopyrightText}
                          shareImage={shareImage}
                          toggleShareImageSwitch={(item, index) =>
                            this.props.toggleShareImageSwitch(item, index)
                          }
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        ) : null}
        {liveNewsStateValues[index].selectedtype == "Video" ? (
          <div>
            <div class="row">
              <text for="text">Upload Video :</text>

              <input
                className="fileInput"
                type="file"
                accept="video/mp4"
                onChange={(e) => this.props.handleUploadVideo(e, index)}
              />
              {!liveNewsStateValues[index].liveNewsVideoURL ? (
                <text for="text" style={{ color: "red", fontSize: 10 }}>
                  Please Upload Video
                </text>
              ) : null}
            </div>
          </div>
        ) : null}
        {liveNewsStateValues[index].liveNewsVideoURL ? (
          <div>
            <video width="320" height="240" controls>
              <source
                src={liveNewsStateValues[index].liveNewsVideoURL}
                type="video/mp4"
              />
            </video>
            <button onClick={() => this.props.removeVideo(index)}>
              Remove
            </button>
          </div>
        ) : null}
        {liveNewsStateValues[index].selectedtype == "youtubeID" ? (
          <div>
            <text for="text">Youtube ID :</text>
            <textarea
              type="text"
              onChange={(value) => {
                this.props.handleYoutubeID(value, index);
              }}
              value={liveNewsStateValues[index].liveNewsYoutubeID}
              placeholder="Please Enter Youtube ID"
            ></textarea>
            {this.props.handleYoutubeIDError(
              liveNewsStateValues[index].liveNewsYoutubeID,
              index
            ) ? (
              <text for="text" style={{ color: "red", fontSize: 10 }}>
                Youtube ID Cannot Be Empty
              </text>
            ) : null}

            {liveNewsStateValues[index].selectedtype == "youtubeID" &&
            liveNewsStateValues[index].selectedtype != "" ? (
              <div>
                <div style={{ marginRight: 10 }}>
                  <input
                    value={liveNewsStateValues[index].isVertical}
                    type="radio"
                    checked={
                      liveNewsStateValues[index].isVertical == "vertical"
                    }
                    onChange={() => {
                      this.props.handleYoutubeVideoType("vertical", index);
                    }}
                  ></input>
                  <text for={"Vertical"}>{"Vertical"}</text>
                </div>
                <div style={{ marginRight: 10 }}>
                  <input
                    value={!liveNewsStateValues[index].isVertical}
                    type="radio"
                    checked={
                      liveNewsStateValues[index].isVertical == "horizontal"
                    }
                    onChange={() => {
                      this.props.handleYoutubeVideoType("horizontal", index);
                    }}
                  ></input>
                  <text for={"Horizontal"}>{"Horizontal"}</text>
                </div>
              </div>
            ) : null}
            {liveNewsStateValues[index].isVertical == "" &&
            !liveNewsStateValues[index].isVertical ? (
              <text for="text" style={{ color: "red", fontSize: 10 }}>
                Youtube Video Orientation Cannot be Empty
              </text>
            ) : null}
            {/* {syncToWordpress ? (
              <div class="row">
                <text for="text">Featured Image For Website</text>
                <div className="App">
                  <ImageUpload
                    pushImageObj={this.props.pushImageObj}
                    setFeaturedImageId={this.props.setFeaturedImageId}
                    multiImages={false}
                    circularCrop={false}
                    isYoutube={true}
                    sectionIndex={this.props.index}
                  />
                  {images.length > 0 ? null : (
                    <text for="text" style={{ color: "red", fontSize: 10 }}>
                      Please upload an image
                    </text>
                  )}
                  {images?.map((item, index) => {
                    const {
                      copyRightText,
                      copyRight,
                      shareImage,
                      key,
                      imageValue,
                      image,
                    } = item;

                    const cdnurl = AwsConfig.cdn_url;
                    let finalImage = image ? image : "";
                    if (finalImage && !finalImage.includes(cdnurl)) {
                      finalImage = cdnurl + image;
                    }
                    const srcImg = image ? finalImage : imageValue;
                    return (
                      <div className="imagesContainer" key={index}>
                        <img style={{ maxWidth: "100%" }} src={srcImg} />
                        <button onClick={() => this.props.removeImage(index)}>
                          Remove Image
                        </button>
                        <div className="imgPreview">
                          <ImageOptions
                            syncToWordpress={syncToWordpress}
                            item={item}
                            copyRight={copyRight}
                            copyRightText={copyRightText}
                            sectionIndex={this.props.index}
                            toggleCopyRightSwitch={(key, index) =>
                              this.props.toggleCopyRightSwitch(key, index)
                            }
                            handleCopyrightType={(
                              key,
                              copyrightPrefix,
                              index
                            ) =>
                              this.props.handleCopyrightType(
                                key,
                                copyrightPrefix,
                                index
                              )
                            }
                            handleCopyrightText={this.props.handleCopyrightText}
                            shareImage={shareImage}
                            toggleShareImageSwitch={(key, index) =>
                              this.props.toggleShareImageSwitch(key, index)
                            }
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : null} */}
          </div>
        ) : null}
      </div>
    );
  }
}
